import * as angular from "angular";

export class ConvertToNumberDirective implements angular.IDirective {

    restrict = 'A';
    require = 'ngModel';

    link(scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        ngModel.$parsers.push((val) => {
            return val != null ? parseInt(val, 10) : null;
        });
        ngModel.$formatters.push((val) => {
            return val != null ? "" + val : null;
        });
    }

    static factory(): angular.IDirectiveFactory {
        return () => new ConvertToNumberDirective();
    }
}
